import { IResult } from '../models/result-models';
import { ITempMessage } from '../models/temp-message';
import { apiGet } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/temp-message';

export const getTempMessages = async (): Promise<IResult<ITempMessage[]>> => {
    const result = await apiGet<ITempMessage[]>(baseUrl);
    return result;
};
